module.exports = __webpack_public_path__ + "media/images/button_GoldLg-e69d7ab56a129e44baa0a6c12ea4db7c.png";